import * as React from 'react';

import { Slug } from '@fnv-core/utils';

import { FormControlProps } from '../interfaces/FormControlProps';

import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { Editor } from '@tinymce/tinymce-react';
import ReactHtmlParser from 'react-html-parser';

export interface RichTextState {
    content: string;
}

export class RichTextEditor extends React.Component<FormControlProps, RichTextState> {
    constructor(props: FormControlProps) {
        super(props);
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }

    state = {
        content: ''
    };

    componentDidMount() {
      this.setState({content: this.props.field.value});
    }

    handleEditorChange(content, editor) {
      this.setState({ content }, () => {
        this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, '');
        this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, content);
        this.props.formikBag.setFieldTouched(
            this.props.formFieldDefinition.name,
            true,
            true
        );
      });
    }
    
    render() {        
        const labelProps = {
            htmlFor: PropertyHelpers.getFieldID(this.props),
            title: FormLabelHelpers.getFieldLabel(this)
        };
        return (
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-textarea-form-group'}>
                <label {...labelProps}>{ReactHtmlParser(FormLabelHelpers.getFieldLabel(this))}</label>
                <div className="input-group">
                    
                    <div className={"mijn-fnv__richTextEditor"}>
                      <Editor 
                        value={this.state.content}                     
                        onEditorChange={this.handleEditorChange}
                        init={
                                {
                                    plugins: 'autoresize paste', 
                                    autoresize_bottom_margin: 10,
                                    menubar: false,
                                    toolbar: false,
                                    content_style: 'p {margin: 0;}',
                                    paste_word_valid_elements: 'b,strong,i,em,h1,h2,h3,h4,h5,p,br,span',
                                    paste_webkit_styles: "font-weight font-style",
                                    theme: 'silver',
                                    mobile: { 
                                        theme: 'silver'
                                    }
                                }
                            } 
                        />
                    </div>
                    <div className="input-group-append form-control--is-valid-indicator">
                        <div className="input-group-text">
                            <span className="icon icon-checkmark" />
                        </div>
                    </div>
                    {FormControlHelpers.invalidFeedbackComponent(this)}
                </div>
            </div>
        );
    }
}

